import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FormInstance } from 'antd';

import {
  Button,
  CheckboxInput,
  Form,
  Icon,
  ICONS,
  PLATFORM_THEME_COLORS,
  TextInput,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';

import { generateReactKey } from 'src/common/helpers/common.helpers';

import { FormListWrapper, DeleteContainer, FormListTitle } from './checklist.styles';

const Checklist = ({
  form,
  isAllowToEdit = false,
}: {
  form: FormInstance<any>;
  isAllowToEdit?: boolean;
}) => {
  const { t } = useTranslation('processBuilder');

  const [title, setTitle] = useState('');

  const handleTitleChange = (e: React.FormEvent<HTMLInputElement>) => {
    setTitle(e.currentTarget.value);
  };

  return (
    <Form.List name={'checklist'}>
      {(fields, { add, remove }) => (
        <FormListWrapper>
          <FormListTitle>
            <Typography weight="bold">{t('processBuilder:tasks.labels.checklist')}</Typography>
            <Button
              disabled={!title}
              type="text"
              icon={ICONS.plus}
              iconColor={PLATFORM_THEME_COLORS.primary.blue}
              onClick={() => {
                add({
                  completed: false,
                  title,
                });
                setTitle('');
              }}
            >
              {t('processBuilder:tasks.buttons.addChecklistItem')}
            </Button>
          </FormListTitle>
          <Fragment>
            {fields.map(field => {
              const formValue = form.getFieldValue(['checklist', field.name]);
              return (
                <DeleteContainer isIcon={fields.length > 0} key={field.key}>
                  <Form.Item {...field} valuePropName="checked" name={[field.name, 'completed']}>
                    <CheckboxInput>
                      <span className={'completed-label'}>{formValue?.title}</span>
                    </CheckboxInput>
                  </Form.Item>
                  <Form.Item
                    {...field}
                    key={generateReactKey()}
                    className={'checklist-title-input'}
                    name={[field.name, 'title']}
                  >
                    <TextInput />
                  </Form.Item>
                  {fields.length > 0 && !isAllowToEdit && (
                    <Icon
                      icon={ICONS.xCircleRegular}
                      rightMargin={false}
                      color={PLATFORM_THEME_COLORS.tone.red}
                      size={20}
                      onClick={() => {
                        remove(field.name);
                      }}
                    />
                  )}
                </DeleteContainer>
              );
            })}
          </Fragment>
          <TextInput
            value={title}
            disabled={isAllowToEdit}
            className={'checkpoint-input'}
            maxLength={300}
            onKeyDown={e => {
              if (e?.key === 'Enter' && title) {
                add({
                  completed: false,
                  title,
                });
                setTitle('');
              }
            }}
            onChange={handleTitleChange}
            placeholder={t('processBuilder:tasks.labels.enterCheckpoint')}
          />
        </FormListWrapper>
      )}
    </Form.List>
  );
};

export default Checklist;
